import { createContext, useContext } from 'react';
export const TrayContext = createContext({
    open: false,
    onClose: undefined,
});
export const useTrayContext = () => useContext(TrayContext);
//# sourceMappingURL=TrayContext.js.map